import en from './en/translation.json';
import ar from './ar/translation.json';
import ur from './ur/translation.json';
import gccAr from './gcc/ar.json';
import { isGCCTenant } from '../utility/env';

// GCC tenants (not KSA) word a few Arabic strings differently; their overrides sit on top of the shared copy.
export default {
  en: { translation: en },
  ar: { translation: isGCCTenant ? { ...ar, ...gccAr } : ar },
  ur: { translation: ur },
};
